import { memo, useState } from 'react';
import { useMountEffect } from '@client/hooks/utils.hooks';
import { LoadingMessage } from '../LoadingMessage';

export const LoaderMessage = memo(() => {
  const [hasLoader, setHasLoader] = useState(false);

  useMountEffect(() => {
    const timer = setTimeout(() => setHasLoader(true), 2000);

    return () => clearTimeout(timer);
  });

  if (hasLoader) {
    return <LoadingMessage />;
  }

  return null;
});
